import _AlertCustom from '../components/_AlertCustom'
window.alert=(text,prompt=false,cb=()=>{})=>{
  _AlertCustom(text,prompt,cb)
}